import { useMemo } from 'react';
import { ReplicateClient } from '@/shared/api/replicate';
import { useSettings } from './useSettings';

export function useReplicateClient(): ReplicateClient | null {
  const [settings] = useSettings();
  return useMemo(() => {
    if (!settings.replicateToken) return null;
    return new ReplicateClient({ token: settings.replicateToken });
  }, [settings.replicateToken]);
}
